<section class="content p-3">
  <div class="container card">
    <div class="d-flex justify-content-between align-items-center mb-3 pt-3 flex-wrap gap-2">
      <app-main-heading 
        [heading]="showListDetails ? 'Stock Summary - Import: ' + (importListDate | date:'dd-MM-yyyy h:mm a':'Asia/Kolkata') : 'Stock Summary - Import'" 
        class="m-0">
      </app-main-heading>
      <div class="d-flex justify-content-end align-items-center flex-wrap gap-1 ms-auto">
        @if(showImportList) {
          <button class="btn app-btn-outline" (click)="refreshList()">
            <fa-icon [icon]="faRotate"></fa-icon> Refresh
          </button>
        }
        @if (showImportList) {
          <button class="btn app-btn-primary" (click)="file.click()">
            <fa-icon [icon]="faFileImport"></fa-icon> Stock Import
          </button>
        }
        <input style="display: none" #file type="file" accept=".xls,.xlsx" (change)="importSheet($event, file)" />
        @if (showImportList) {
        <button class="btn app-btn-primary" routerLink="/home" (click)="back()">Back</button>
        }
        @if (showListDetails) {
          <button class="btn app-btn-primary" (click)="goBack()">Back</button>
        }
      </div>
    </div>

    @if (showImportList) {
      <div class="card app-table-thick-border shadow-none mb-2">
        <div class="table-responsive app-scrollbar" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500"
          (scrolled)="onScroll()" [scrollWindow]="false">
          <table class="table app-table-rounded align-middle m-0 w-100">
            <thead>
              <tr class="app-table-header">
                <th>File Name</th>
                <th>Status</th>
                <th>Uploaded By</th>
                <th>Import Date</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              @if (sheetList.length > 0) {
                @for (name of sheetList; track name) {
                  <tr class="app-table-body app-td-text">
                    <td class="td-text-one">{{name?.filePath}}</td>
                    <td class="td-text-two">{{name?.status}}</td>
                    <td class="td-text-three">{{name?.createdBy?.name}}</td>
                    <td class="td-text-one ">{{name?.created | date:'dd-MM-yyyy h:mm a':'Asia/Kolkata'}}</td>
                    <td>
                      @if(name?.status?.toLowerCase() == "completed") {
                        <fa-icon [icon]="faEye" (click)="showListDts(name?._id,name?.completedAt)" class="view-icon"></fa-icon>
                      } @else if (name?.status?.toLowerCase() == "fail") {
                        <fa-icon class="view-icon text-danger" [icon]="faTriangleExclamation"
                          [ngbTooltip]="name?.reason"></fa-icon>
                      }
                    </td>
                  </tr>
                }
              }

              <!-- Loader Row -->
              @if (loader) {
                <tr>
                  <td colspan="5">
                    <div class="custom-col-width-100 d-flex justify-content-center py-5">
                      <app-loader [loadingIcon]="loader"></app-loader>
                    </div>
                  </td>
                </tr>
              }

              <!-- Empty State Row -->
              @if (sheetList.length === 0 && !loader) {
                <tr>
                  <td colspan="5">
                    <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                      No data Found!
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

    @if (showListDetails) {
      <div class="card app-table-thick-border shadow-none mb-2">
        <div class="table-responsive app-scrollbar second-scroll">
          <table class="table app-table-rounded align-middle m-0 w-100">
            <thead>
              <tr class="app-table-header text-nowrap">
                <th>Make</th>
                <th>Model</th>
                <th>Size</th>
                <th>Branch</th>
                <th>Stock Qty</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @if (stockListDetails?.length >= 1) {
                @for (rowData of stockListDetails; track rowData) {
                  <tr class="app-table-body app-td-text">
                    <td class="td-text-two">{{rowData?.tyreMake}}</td>
                    <td class="td-text-two">{{rowData?.tyreModel}}</td>
                    <td class="text-nowrap td-text-two">{{rowData?.tyreSize}}</td>
                    <td class="td-text-two">{{rowData?.branch}}</td>
                    <td class="td-text-three">{{rowData?.stock}}</td>
                    <td [ngClass]="rowData?.status == 'Success' ? 'td-text-green': 'td-text-red'">
                      {{rowData?.status}}
                      @if (rowData?.status === 'Success' && rowData?.remarks) {
                        <fa-icon [icon]="faCircleInfo"
                          class="text-success" data-bs-toggle="tooltip" ngbTooltip="{{rowData?.remarks}}" placement="left">
                        </fa-icon>
                      }
                      @if (rowData?.status === 'Failed') {
                        <fa-icon [icon]="faCircleInfo" class="text-danger"
                          data-bs-toggle="tooltip" ngbTooltip="{{rowData?.errorMessage}}" placement="left">
                        </fa-icon>
                      }
                    </td>
                  </tr>
                }
              }

              @if (loader) {
                <tr>
                  <td colspan="6">
                    <div class="custom-col-width-100 d-flex justify-content-center py-5">
                      <app-loader [loadingIcon]="loader"></app-loader>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
      @if (errorMessage) {
        <div class="text-center text-danger pt-2">
          {{errorMessage}}
        </div>
      }
    </div>
  </section>

  <ng-template #importConfirmationModal let-modal>
    <div class="modal-header border-0 pb-0">
      <div>
        <h4 class="modal-title mb-1">Confirm Stock Import</h4>
        <p class="text-muted mb-0 small">Review import behavior to prevent accidental data loss.</p>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body pt-3">
      <div class="row g-3">
        <!-- Update existing option -->
        <div class="col-md-4">
          <div class="import-option-card" [class.selected]="selectedImportOption === 'Update'"
            (click)="selectImportOption('Update')">
            <div class="d-flex justify-content-between align-items-start mb-1">
              <div>
                <h6 class="option-title">Update existing</h6>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="importOption" id="updateOption"
                  [checked]="selectedImportOption === 'Update'" (change)="selectImportOption('Update')">
              </div>
            </div>
            <p class="option-description text-muted small">
              System has stock of <strong class="text-secondary">Sku1</strong>, <strong class="text-secondary">Sku2</strong>, <strong class="text-secondary">Sku3</strong>. The sheet contains updated quantity for <strong class="text-secondary">Sku3</strong> and new SKUs <strong class="text-secondary">Sku4</strong>, <strong class="text-secondary">Sku5</strong>. This will update matching <strong class="text-secondary">Sku3</strong> and add new <strong class="text-secondary">Sku4</strong> and <strong class="text-secondary">Sku5</strong>, while leaving <strong class="text-secondary">Sku1</strong>, <strong class="text-secondary">Sku2</strong> unchanged.
            </p>
            <div class="resulting-action mt-1">
              <span class="badge bg-light text-dark small">RESULTING ACTION</span>
              <div class="action-tags mt-2">
                <span class="badge bg-secondary me-1">Sku1</span>
                <span class="badge bg-secondary me-1">Sku2</span>
                <span class="badge bg-primary me-1">Sku3</span>
                <span class="badge bg-success me-1">Sku4</span>
                <span class="badge bg-success">Sku5</span>
              </div>
              <p class="small text-muted mt-2 mb-0">Existing Sku1 & Sku2 remain same. Matching Sku3 is updated. New Sku4 & Sku5 are added.</p>
            </div>
          </div>
        </div>

        <!-- Wipe out and Import option -->
        <div class="col-md-4">
          <div class="import-option-card" [class.selected]="selectedImportOption === 'WipeOut'"
            (click)="selectImportOption('WipeOut')">
            <div class="d-flex justify-content-between align-items-start mb-1">
              <div>
                <h6 class="option-title text-danger">Wipe out and Import</h6>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="importOption" id="wipeOption"
                  [checked]="selectedImportOption === 'WipeOut'" (change)="selectImportOption('WipeOut')">
              </div>
            </div>
            <p class="option-description text-muted small">
              System has stock of <strong class="text-secondary">Sku1</strong>, <strong class="text-secondary">Sku2</strong>, <strong class="text-secondary">Sku3</strong>, <strong class="text-secondary">Sku4</strong>, and <strong class="text-secondary">Sku5</strong>. The sheet contains <strong class="text-secondary">Sku1</strong>, <strong class="text-secondary">Sku4</strong>, and <strong class="text-secondary">Sku5</strong>. This will replace current stock entirely. Only SKUs in the sheet (<strong class="text-secondary">Sku1</strong>, <strong class="text-secondary">Sku4</strong>, <strong class="text-secondary">Sku5</strong>) will remain, and <strong class="text-secondary">Sku2</strong> and <strong class="text-secondary">Sku3</strong> will be deleted.
            </p>
            <div class="resulting-action mt-1">
              <span class="badge bg-danger-subtle text-danger small">DESTRUCTIVE ACTION</span>
              <div class="action-tags mt-2">
                <span class="badge bg-success me-1">Sku1</span>
                <span class="badge bg-success me-1">Sku4</span>
                <span class="badge bg-success me-1">Sku5</span>
                <span class="badge strick-badge bg-danger-subtle text-danger me-1">Sku2</span>
                <span class="badge strick-badge bg-danger-subtle text-danger">Sku3</span>
              </div>
              <p class="small text-muted mt-2 mb-0">Sku2 & Sku3 will be removed from system. Only Sku1, Sku4 & Sku5 remain.</p>
            </div>
          </div>
        </div>

        <!-- Append and update option -->
        <div class="col-md-4">
          <div class="import-option-card" [class.selected]="selectedImportOption === 'Append'"
            (click)="selectImportOption('Append')">
            <div class="d-flex justify-content-between align-items-start mb-1">
              <div>
                <h6 class="option-title">Append and update</h6>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="importOption" id="appendOption"
                  [checked]="selectedImportOption === 'Append'" (change)="selectImportOption('Append')">
              </div>
            </div>
            <p class="option-description text-muted small">
              System has stock of <strong class="text-secondary">Sku1</strong>, <strong class="text-secondary">Sku2</strong>, <strong class="text-secondary">Sku3</strong>. The sheet contains additional quantity for <strong class="text-secondary">Sku3</strong> and new SKUs <strong class="text-secondary">Sku4</strong>, <strong class="text-secondary">Sku5</strong>. This will add sheet quantity to existing <strong class="text-secondary">Sku3</strong> and create new <strong class="text-secondary">Sku4</strong> and <strong class="text-secondary">Sku5</strong>, while leaving <strong class="text-secondary">Sku1</strong>, <strong class="text-secondary">Sku2</strong> unchanged.
            </p>
            <div class="resulting-action mt-1">
              <span class="badge bg-light text-dark small">RESULTING ACTION</span>
              <div class="action-tags mt-2">
                <span class="badge bg-secondary me-1">Sku1</span>
                <span class="badge bg-secondary me-1">Sku2</span>
                <span class="badge bg-primary me-1">Sku3 (+Qty)</span>
                <span class="badge bg-success me-1">Sku4</span>
                <span class="badge bg-success">Sku5</span>
              </div>
              <p class="small text-muted mt-2 mb-0">Existing Sku1 & Sku2 remain same. Sheet quantity is added to Sku3. New Sku4 & Sku5 are added.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer border-0 pt-0">
      <!-- Warning message -->
      <div class="alert alert-warning w-100 mb-1 small" role="alert">
        <div>
          <strong>This action cannot be undone.</strong> We recommend exporting a backup of your current stock
          summary before proceeding with a full wipe.
        </div>
      </div>

      <div class="d-flex justify-content-end w-100">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="modal.dismiss('Cancel')">Cancel</button>
        <button type="button" class="btn app-btn-primary" [disabled]="!selectedImportOption"
          (click)="confirmUpload(selectedImportOption)">
          Proceed with Import
        </button>
      </div>
    </div>
      </ng-template>